<script>
import ModalResponseActivityAnswerComponent from '../../features/modals/ModalResponseActivityAnswerComponent';

export default {
  name: 'ModalResponseActivityAnswerView',
  components: {},
  extends: ModalResponseActivityAnswerComponent,
};
</script>

<template>
  <div>
    <el-dialog
      v-model="conf.isVisible"
      title="Revisión de Actividad"
      width="50%"
      class="response-activity-answer-modal"
      append-to-body
      :before-close="onCancel"
      :close-on-click-modal="false"
    >
      <el-form
        ref="formData"
        v-loading="conf.isLoading"
        :model="formData"
        :rules="rules"
        status-icon
        :label-position="'top'"
      >
        <fieldset>
          <legend>Actividad</legend>
          <br>
          <el-row
            type="flex"
            class="row-bg"
            :gutter="20"
          >
            <el-col :span="24">
              <div v-html="formData.courseSubjectActivity.title" />
            </el-col>
          </el-row>
          <br>
        </fieldset>
        <fieldset>
          <legend>Descripci&oacute;n</legend>
          <br>
          <el-row
            type="flex"
            class="row-bg"
            :gutter="20"
          >
            <el-col :span="24">
              <div v-html="formData.courseSubjectActivity.description" />
            </el-col>
          </el-row>
          <br>
        </fieldset>
        <fieldset>
          <legend>Respuesta</legend>
          <br>
          <el-row
            type="flex"
            class="row-bg"
            :gutter="20"
          >
            <el-col :span="24">
              <div v-html="formData.contentResponse" />
            </el-col>
          </el-row>
          <br>
          <el-row
            type="flex"
            class="row-bg"
            :gutter="20"
          >
            <el-col :span="24">
              <el-form-item prop="success">
                <el-switch
                  v-model="formData.success"
                  style="display: block"
                  active-color="#13ce66"
                  inactive-text="Incorrecto"
                  active-text="Correcto"
                  :inactive-value="false"
                  :active-value="true"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </fieldset>
        <fieldset>
          <legend>Observaci&oacute;n</legend>
          <br>
          <el-row
            type="flex"
            class="row-bg"
            :gutter="20"
          >
            <el-col :span="24">
              <el-form-item prop="contentObservation">
                <el-input
                  v-model="formData.contentObservation"
                  type="textarea"
                  :row="3"
                  size="small"
                  class="description-editor"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </fieldset>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button
            size="small"
            class="btn-cancel"
            @click="onCancel"
          >Cancelar</el-button>
          <el-button
            type="primary"
            :disabled="!onCanSaveOrUpdate()"
            class="btn-primary"
            size="small"
            @click="onSubmitForm('formData')"
          >Guardar</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
